(function () {
  'use strict';

  angular.module('app').component('planList', planList());

  function planList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        loadingItems: '<',
        onShowItem: '&',
      },
      controller: PlanListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/plans/plan-list/plan-list.component.html',
    };
  }

  PlanListCtrl.$inject = ['UtilService', 'PlanService'];

  function PlanListCtrl(UtilService, PlanService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = PlanService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.changeItemStatus = changeItemStatus;
    vm.onUpdateItems = onUpdateItems;

    function fetchResult() {
      vm.loadingItems = true;
      PlanService.getPlans(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = PlanService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      vm.onShowItem({ item: item, mode: mode });
    }

    function changeItemStatus(item) {
      PlanService.changePlanStatus(item);
    }

    function onUpdateItems(action) {
      var successCallback = function () {
        vm.showActions = false;
        vm.selectedAll = false;

        if (action === 'destroy') {
          fetchResult();
        }
      };

      PlanService.updatePlans(action, vm.items, successCallback);
    }
  }
})();
